import { useAppSelector } from '@/configureStore';
import { selectIsActive } from './activitySlice';

import styles from './Dots.module.scss';

export const Dots = () => {
  const shouldShow = useAppSelector((state) => selectIsActive(state));

  return shouldShow ? (
    <div className={styles.dots}>
      <div className={styles.dotbricks}></div>
    </div>
  ) : null;
};
